import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../../utils/helpers/model.helper';
import { ITrackingObject, TrackingObjectNamesEnum } from '../../tracking.data';

export const TRACKING_JOB_SCHEMA = Object.freeze({
  ID: '',
});
const RECORD = generateSchema(TRACKING_JOB_SCHEMA);
const KEYS: any = generateKeys(TRACKING_JOB_SCHEMA);

export class JobTrackingObject
  extends Record(RECORD)
  implements ITrackingObject {
  static KEYS = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get name() {
    return TrackingObjectNamesEnum.job;
  }

  get properties() {
    return this.toJS();
  }
}
